module.exports = __webpack_public_path__ + "static/media/sparkles@3x.4e27de3a.png";